import React, { FC, useState } from 'react';
import { Button, Card } from 'antd';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import HyperLink, { ENTITY_TYPE, HYPERLINK_VARIANT } from '../common/HyperLink';
import EditAccessibleLocationsModal from './EditAccessibleLocationsModal';

const FieldTechAccessibleLocationsCard: FC<any> = ({
	fieldTech,
	onLocationsUpdated,
}): React.ReactElement => {
	const [showEdit, setShowEdit] = useState(false);

	const email = nullSafeGet('email', fieldTech);
	const hasAccessToAllLocations = nullSafeGet('hasAccessToAllLocations', fieldTech);
	const locations = nullSafeGetOrElse('locations', fieldTech, []);

	const openEdit = () => setShowEdit(true);
	const closeEdit = () => setShowEdit(false);

	const handleEditSuccess = () => {
		setShowEdit(false);
		onLocationsUpdated && onLocationsUpdated();
	};

	const renderBody = () => {
		if (hasAccessToAllLocations) {
			return 'All locations';
		}
		if (locations.length > 0) {
			return (
				<div>
					{locations.map((location) => (
						<HyperLink
							key={`location-${location.id}`}
							text={location.name}
							entityType={ENTITY_TYPE.LOCATION}
							entityId={location.id}
							backLinkText={'Back to Field Tech Detail'}
							variant={HYPERLINK_VARIANT.SUBTLE}
						/>
					))}
				</div>
			);
		}
		return 'No Locations Accessible';
	};

	return (
		<div className="rowSpacing">
			<Card
				title="Accessible Locations"
				extra={
					<AccessPermissionChecker
						name={PERMISSION_NAMES.ASSIGN_ACCESS_TO_LOCATIONS}
						permissionDeniedContent={null}
					>
						<Button type="link" onClick={openEdit}>
							Edit
						</Button>
					</AccessPermissionChecker>
				}
			>
				{renderBody()}
			</Card>
			{showEdit && (
				<EditAccessibleLocationsModal
					email={email}
					hasAccessToAllLocations={!!hasAccessToAllLocations}
					locationIds={locations.map((location) => location.id)}
					onCancel={closeEdit}
					onSuccess={handleEditSuccess}
				/>
			)}
		</div>
	);
};

export default FieldTechAccessibleLocationsCard;
